import { WebSocketStatus, WsMessage } from '@numeo/types-core'
import { useDispatch, useSelector } from 'react-redux'
import { sendWebSocketMessage } from '../services/websocketApi'
import { RootState } from '../store'
import { connecting } from '../store/webSocketSlice'

export const useWebSocketRedux = () => {
    const dispatch = useDispatch()
    const status = useSelector((state: RootState) => state.webSocket.status)
    const wsError = useSelector((state: RootState) => state.webSocket.error)
    const isReplaying = useSelector((state: RootState) => state.webSocket.isReplaying)
    const disconnectedSince = useSelector((state: RootState) => state.webSocket.disconnectedSince)

    return {
        status,
        error: wsError,
        isConnected: status === WebSocketStatus.CONNECTED,
        isReplaying,
        disconnectedSince,
        sendMessage: async (message: WsMessage) => {
            await sendWebSocketMessage(message)
        },
        // Manual reconnect for developer testing - triggers new connection attempt
        reconnect: () => dispatch(connecting()),
    }
}
